import React from 'react';
import {Col, Row} from "react-bootstrap";
import * as acc from "accounting";

const BKDaneOBilecie = ({bilet,statusy}) => {

    const renderPartInformation = (icon, label, value, bold, isHidden = false) => {
        if (!isHidden)
            return (
                <Row style={{marginTop:'8px'}}>
                    <Col xs={6} lg={6}>
                        <i className={icon} style={{width:'25px'}}/> {label}
                    </Col>
                    <Col xs={6} lg={6}>
                        <span style={bold ? {fontWeight: 'bold'} : {}}>{value}</span>
                    </Col>
                </Row>
            )
    }

    const setInformacjeOBilecie = () => {

        let status = statusy.find(s => s.value === bilet.statBil);

        let arr = [
            {
                icon: 'fa fa-bus',
                label: 'Kod biletu z paragonu',
                value: (bilet.biletBusId)?bilet.biletBusId:'brak paragonu',
            },
            {
                icon: 'fa fa-ticket',
                label: 'Główny kod biletu',
                value: bilet.idBi,
                bold: true
            },
            {
                icon: 'fa fa-money',
                label: 'Całkowita kwota',
                value: acc.formatMoney(bilet.kwota),
            },
            {
                icon: 'fa fa-clock-o',
                label: 'Data transakcji',
                value: bilet.dataWpisu.replace("T", " ").substr(0, 19),
            },
            {
                icon: 'fa fa-clock-o',
                label: 'Data modyfikacji',
                value: (bilet.dataZmiany)?bilet.dataZmiany.replace("T", " ").substr(0, 19):'-',
            },
            {
                icon: 'fa fa-clock-o',
                label: 'Data wysłanie emaila',
                value: (bilet.klientEmailPotw)?bilet.klientEmailPotw.replace("T", " ").substr(0, 19):'-',
            },
            {
                icon: 'fa fa-credit-card',
                label: 'Transakcja EBUS',
                value: bilet.platnosciTransakcja,
            },
            {
                icon: 'fa fa-credit-card',
                label: 'Płatność TPAY',
                value: (bilet.biletyPoz[0].platnoscTpay)?bilet.biletyPoz[0].platnoscTpay:'-',
            },
            {
                icon: 'fa fa-thumb-tack',
                label: 'Miejsce sprzedaży',
                value: bilet.sprzedazMiejsce,
            },
            {
                icon: (status)?status.ikona:'',
                label: 'Status biletu',
                value: (status)?status.label:'?',
            },
        ];

        return arr.map(({icon, label, value, bold}) => renderPartInformation(icon, label, value, bold))
    };

    const setInformacjeOKursie = () => {
        let arr = [
            {
                icon: 'fa fa-exchange',
                label:'Numer kursu',
                value:bilet.biletyPoz[0].idKu,
                bold:true,
            },
            {
                icon: 'fa fa-road',
                label:'Trasa',
                value:bilet.biletyPoz[0].nazTr,
            },
            {
                icon: 'fa fa-sign-in',
                label:'Od',
                value:bilet.biletyPoz[0].nazMiOd+" "+bilet.biletyPoz[0].nazPrOd,
            },
            {
                icon: 'fa fa-sign-out',
                label:'Do',
                value:bilet.biletyPoz[0].nazMiDo+" "+bilet.biletyPoz[0].nazPrDo,
            },
            {
                icon: 'fa fa-clock-o',
                label:'Data i godzina',
                value:bilet.biletyPoz[0].waznyOd + ', ' + bilet.biletyPoz[0].godz.replace('.', ':'),
            },
        ];
        return arr.map(({icon, label, value, bold}) => renderPartInformation(icon, label, value, bold))
    };

    const setInformacjeOKliencie = () =>{
        let arr =[];
        if(bilet.idKl !== 1){
            arr = [
                {
                    icon: 'fa fa-id-badge',
                    label:'Klient ID',
                    value:bilet.idKl,
                    bold:true,
                },
                {
                    icon: 'fa fa-user-circle-o',
                    label:'Klient',
                    value:bilet.klientNazwa,
                    bold:true,
                    isHidden:(!Boolean(bilet.klientNazwa))
                },
                {
                    icon: 'fa fa-envelope',
                    label:'Email',
                    value:(bilet.klientEmail)?bilet.klientEmail:'-',
                },
                {
                    icon: 'fa fa-phone',
                    label:'Telefon',
                    value:(bilet.klientTelefon)?bilet.klientTelefon:'-',
                },
            ]
        }else{
            arr=[
                {
                    icon: 'fa fa-user-secret',
                    label:'KLIENT JEDNORAZOWY',
                    value:'',
                    bold:true,
                },
                {
                    icon: 'fa fa-user-secret',
                    label:'Klient',
                    value:(bilet.klientNazwa)?bilet.klientNazwa:"Klient anonimowy",
                },
                {
                    icon: 'fa fa-envelope',
                    label:'Email',
                    value:(bilet.klientEmail)?bilet.klientEmail:'-',
                },
                {
                    icon: 'fa fa-phone',
                    label:'Telefon',
                    value:(bilet.klientTelefon)?bilet.klientTelefon:'-',
                },
            ]
        }
        return arr.map(({icon, label, value, bold,isHidden}) => renderPartInformation(icon, label, value, bold,isHidden));
    };

    return (
        <div>
            <Row>
                <Col lg={4}>
                    <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o bilecie</h5>
                    {setInformacjeOBilecie()}
                </Col>
                <Col lg={4}>
                    <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o kursie</h5>
                    {setInformacjeOKursie()}
                </Col>
                <Col lg={4}>
                    <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o kliencie</h5>
                    {setInformacjeOKliencie()}
                    <h5 style={{fontStyle: 'italic', color: 'grey'}}>Informacje o NIP</h5>
                    {
                        renderPartInformation('fa fa-asterisk','NIP na paragonie',(bilet.biletyPoz[0].nipParagon)?bilet.biletyPoz[0].nipParagon:'-',true)
                    }
                </Col>
            </Row>
        </div>
    );
};

export default BKDaneOBilecie;


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/bilety_kod_z_paragonu_components/BKDaneOBilecie.js